/* Product examples follow the current Shopify lead image, independently of saved page HTML.
   Dedicated collection artwork is deliberately outside this resolver. */
(function () {
  'use strict';
  var jobs = [], active = 0, cache = new Map(), seen = new WeakSet();
  function product(handle) {
    if (!cache.has(handle)) cache.set(handle, new Promise(function (resolve, reject) {
      jobs.push(function () {
        active++;
        var controller = new AbortController(), timeout = setTimeout(function () { controller.abort(); }, 12000);
        fetch('/products/' + encodeURIComponent(handle) + '.js', { signal: controller.signal })
          .then(function (response) { if (!response.ok) throw new Error('Product unavailable'); return response.json(); })
          .then(function (p) { if (!p.featured_image) throw new Error('No lead image'); resolve(p); }).catch(reject)
          .finally(function () { clearTimeout(timeout); active--; pump(); });
      });
      pump();
    }));
    return cache.get(handle);
  }
  function pump() { while (active < 4 && jobs.length) jobs.shift()(); }
  function load(img) {
    var anchor = img.closest('a[href*="/products/"]');
    var handle = img.dataset.stProductHandle || (anchor && new URL(anchor.href).pathname.split('/products/')[1]);
    if (!handle) return;
    product(handle).then(function (p) {
      var url = new URL(p.featured_image, location.origin); url.searchParams.set('width', '720');
      img.removeAttribute('srcset'); img.src = url.href;
      var media = (p.media || []).find(function (m) { return m.preview_image && m.preview_image.src === p.featured_image; });
      img.alt = (media && media.alt) || p.title;
      img.dataset.stLeadResolved = 'true';
    }).catch(function () { img.dataset.stLeadResolved = 'unavailable'; });
  }
  var observer = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) { if (entry.isIntersecting) { observer.unobserve(entry.target); load(entry.target); } });
  }, {rootMargin:'600px'}) : null;
  function scan(root) {
    var selector = 'img[data-st-product-handle], .st-best__card img, .st-color__product img';
    if (location.pathname.indexOf('/pages/') === 0) selector += ', main a[href*="/products/"] img';
    root.querySelectorAll(selector).forEach(function (img) {
      if (seen.has(img)) return; seen.add(img); if (observer) observer.observe(img); else load(img);
    });
  }
  function start() {
    scan(document);
    new MutationObserver(function (changes) { changes.forEach(function (change) { change.addedNodes.forEach(function (node) { if (node.nodeType === 1) { if (node.matches('img[data-st-product-handle]') && !seen.has(node)) { seen.add(node); if (observer) observer.observe(node); else load(node); } scan(node.parentElement || node); } }); }); }).observe(document.body, {childList:true,subtree:true});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
